import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/techniques`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer toutes les techniques
export const getAllTechniques = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allTechniques`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des techniques:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour afficher les techniques judo uniquement sans les familles : Kata, Vocabulaire, Les Bases, Ukemi
export const getTechniquesJudo = async () => {
  try {
    const response = await axios.get(`${apiUrl}/techniques-judo`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des techniques judo:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour afficher les techniques judo uniquement sans les familles : Kata, Vocabulaire, Les Bases, Ukemi et Self Défense
export const getJudoTechniquesWithoutSelfDefense = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/techniques-judo-without-self-defense`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error(
      "Erreur lors du chargement des techniques judo sans self-defense:",
      error,
    );
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour afficher uniquement les techniques qui font parti de l'UV2
export const getTechniquesUV2 = async () => {
  try {
    const response = await axios.get(`${apiUrl}/techniques-uv2`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des techniques UV2:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour afficher uniquement les techniques de la famille Kata
export const getTechniquesKata = async () => {
  try {
    const response = await axios.get(`${apiUrl}/techniques-kata`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des techniques Kata:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour récupérer les techniques favorites d'un utilisateur
export const getFavoriteTechniques = async (userId) => {
  try {
    const response = await axios.get(`${apiUrl}/favorites/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des techniques favorites:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour récupérer les techniques pour les révisions
export const getRevisionTechniques = async ({
  includeSelfDefense = false,
} = {}) => {
  try {
    const response = await axios.get(`${apiUrl}/revisions`, {
      params: {
        includeSelfDefense,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des révisions :", error);
    throw error;
  }
};
